export default function AdvertisementPostSection() {
  const adSlots = [
    {
      id: 1,
      title: "Luxury Real Estate — Beverly Hills",
      image: "https://public.readdy.ai/ai/img_res/2fbafbb88c6d8e2697d78a2cba6172cf.jpg",
      tag: "Real Estate",
      price: "From $2.5M",
      cta: "View Properties",
    },
    {
      id: 2,
      title: "Executive MBA Program 2026",
      image: "https://readdy.ai/api/search-image?query=executive%20MBA%20business%20school%20university%20campus%20professional%20modern%20clean%20elegant&width=600&height=400&seq=adpost2&orientation=landscape",
      tag: "Education",
      price: "Scholarships Available",
      cta: "Apply Now",
    },
    {
      id: 3,
      title: "Premium Health Insurance Plans",
      image: "https://readdy.ai/api/search-image?query=health%20insurance%20medical%20professional%20doctor%20hospital%20clean%20modern%20bright&width=600&height=400&seq=adpost3&orientation=landscape",
      tag: "Insurance",
      price: "From $89/month",
      cta: "Get Quote",
    },
  ];

  return (
    <section id="advertisement-post" className="py-16 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-6">
          <div>
            <span className="text-amber-500 text-sm font-semibold uppercase tracking-wider">Premium Ads</span>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-1">Advertisement &amp; Job Post</h2>
          </div>
          <button className="text-sm font-semibold px-5 py-2.5 rounded-lg bg-amber-500 hover:bg-amber-600 text-white transition-colors cursor-pointer whitespace-nowrap w-fit flex items-center gap-2">
            <i className="ri-add-circle-line"></i>Post Your Ad or Job
          </button>
        </div>

        {/* Availability Banner */}
        <div className="bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200 rounded-2xl p-5 mb-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-5">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 flex items-center justify-center bg-amber-500 rounded-full flex-shrink-0">
                <i className="ri-vip-crown-fill text-white text-2xl"></i>
              </div>
              <div>
                <h3 className="font-bold text-gray-900 text-lg md:text-xl">Welcome — Join Us As Soon As Possible!</h3>
                <p className="text-stone-600 text-sm mt-0.5">Already <span className="font-bold text-amber-600">100 companies</span> have posted their Advertisement &amp; Job listings. Don&apos;t miss your spot!</p>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 flex-shrink-0 w-full md:w-auto">
              <div className="flex-1 md:flex-none text-center bg-white rounded-xl px-5 py-3 border border-amber-200">
                <p className="text-2xl font-bold text-amber-500">100</p>
                <p className="text-xs text-stone-500 mt-0.5">Companies Joined</p>
              </div>
              <div className="flex-1 md:flex-none text-center bg-amber-500 rounded-xl px-5 py-3">
                <p className="text-2xl font-bold text-white">800</p>
                <p className="text-xs text-amber-100 mt-0.5">Spots Still Available</p>
              </div>
            </div>
          </div>

          {/* Progress Bar */}
          <div className="mt-4">
            <div className="flex justify-between text-xs text-stone-500 mb-1.5">
              <span>Slots filled: <strong className="text-amber-600">100 / 900</strong></span>
              <span className="text-green-600 font-semibold">800 spots remaining — act fast!</span>
            </div>
            <div className="w-full bg-stone-200 rounded-full h-3 overflow-hidden">
              <div
                className="h-full bg-gradient-to-r from-amber-400 to-amber-500 rounded-full transition-all duration-1000"
                style={{ width: "11.1%" }}
              ></div>
            </div>
          </div>
        </div>

        {/* Ad Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {adSlots.map((ad) => (
            <div key={ad.id} className="bg-white rounded-xl overflow-hidden border border-stone-100 hover:border-amber-200 hover:shadow-sm transition-all duration-200 cursor-pointer group">
              <div className="relative h-48 overflow-hidden">
                <img
                  src={ad.image}
                  alt={ad.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 bg-amber-500 text-white text-xs font-bold px-2.5 py-1 rounded-full">
                  {ad.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-semibold text-gray-900 text-sm mb-2">{ad.title}</h3>
                <div className="flex items-center justify-between">
                  <span className="text-amber-600 font-bold text-sm">{ad.price}</span>
                  <button className="text-xs font-semibold px-4 py-1.5 rounded-lg bg-amber-50 text-amber-600 hover:bg-amber-500 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                    {ad.cta}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Ad Placement CTA */}
        <div className="bg-gradient-to-r from-amber-500 to-orange-500 rounded-2xl p-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-white text-center md:text-left">
            <h3 className="text-xl md:text-2xl font-bold mb-2">Advertise Your Business Here</h3>
            <p className="text-white/80 text-sm">Reach 500,000+ daily visitors. Flexible ad packages starting at $49/week.</p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
            <button className="bg-white text-amber-600 font-semibold px-6 py-3 rounded-lg hover:bg-amber-50 transition-colors cursor-pointer whitespace-nowrap text-sm">
              View Packages
            </button>
            <button className="border border-white/50 text-white font-semibold px-6 py-3 rounded-lg hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap text-sm">
              Contact Sales
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
